import Model from '../Model'
import OrderItem from './OrderItem'

export default class Order extends Model {
  resource () {
    return 'orders'
  }

  primaryKey () {
    return 'id'
  }

  items () {
    return this.hasMany(OrderItem)
  }
}
